import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Send } from "lucide-react";
import { organisations } from "../data/mock";

const Organisations = () => {
  return (
    <div>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10 grid md:grid-cols-[1fr_auto] gap-6 items-start">
        <div>
          <div className="section-eyebrow text-[#0d2a20]/60 mb-6">Organisations we support</div>
          <h1 className="hero-title text-[52px] md:text-[104px] leading-[0.95] max-w-[900px]">The <span className="font-serif-i text-[#e0684d]">builders</span>.</h1>
          <p className="mt-8 max-w-[820px] text-[17px] leading-relaxed text-[#0d2a20]/80">A growing directory of Nigerian organisations already equipping young people for the future — and that we are proud to strengthen.</p>
        </div>
        <div className="rounded-lg p-5 max-w-[280px]" style={{ background: '#0f3d2e', color: '#f4efe4' }}>
          <div className="section-eyebrow text-[#f4efe4]/60 mb-2">For organisations</div>
          <h3 className="hero-title text-[22px] leading-tight mb-3">Apply for <span className="font-serif-i text-[#e0684d]">Vemoye support</span></h3>
          <p className="text-[12px] text-[#f4efe4]/80 leading-relaxed mb-4">Join our waiting list for consultancy, diaspora expertise and physical-resource support.</p>
          <Link to="/apply-for-support" className="inline-flex items-center gap-1 px-4 py-2 rounded-md btn-coral text-[12px]"><Send size={12} /> Apply now</Link>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {organisations.map(o => (
            <div key={o.id} className="rounded-lg p-6 org-card" style={{ background: '#fbf8ef' }}>
              <div className="flex items-center gap-2 text-[12px] text-[#0d2a20]/60 mb-6">
                <span className="px-2 py-1 rounded" style={{ background: '#ece5d3' }}>{o.tag}</span>
                <span className="flex items-center gap-1"><MapPin size={12} />{o.city}</span>
              </div>
              <h3 className="text-[22px] font-medium mb-2">{o.name}</h3>
              <p className="text-[14px] leading-relaxed text-[#0d2a20]/70 mb-6">{o.desc}</p>
              <div className="flex items-center justify-between pt-4 border-t" style={{ borderColor: 'rgba(13,42,32,0.08)' }}>
                <div><div className="text-[11px] text-[#0d2a20]/60">Youth reached</div><div className="text-[20px] font-medium">{o.reached}</div></div>
                <a href={o.site} target="_blank" rel="noreferrer" className="text-[13px] flex items-center gap-1 link-underline text-[#e0684d]">Visit website <ArrowUpRight size={14} /></a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Organisations;
